export default {
  less: '\ue6a5',
  'more_unfold': '\ue6a6',
  back: '\ue697',
  more: '\ue6a7',
  add: '\ue6b9',
  subtract: '\ue6fe',
  close: '\ue69a',
  cry: '\ue69c',
  delete: '\ue69d',
  help: '\ue6a3',
  refresh: '\ue6aa',
  search: '\ue6ac',
  success: '\ue6b1',
  warning: '\ue6b6',
  wrong: '\ue6b7',
  clock: '\ue6bb',
  scanning: '\ue6ec',
  filter: '\ue6f1',
  map: '\ue715',
  play: '\ue719'
}



// WEBPACK FOOTER //
// ./packages/wxc-icon/type.js